import { useState } from 'react';

function UnderstandingOfStockMarketEssentialModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to the Stock Market Essentials",
      content: [
        "What is the Stock Market?",
        "Definition and role of the stock market in the economy.",
        "The importance of stock markets for businesses, investors, and economic growth.",
        "How the stock market functions as a platform for buying and selling securities."
      ]
    },
    {
      title: "Module 2: Types of Stock Markets",
      content: [
        "Understanding Different Market Types",
        "Primary Market: Where new stocks are issued through IPOs (Initial Public Offerings).",
        "Secondary Market: Where existing stocks are traded between investors (e.g., NSE, BSE).",
        "Over-the-Counter (OTC) Market: Non-exchange trading of stocks and its role."
      ]
    },
    {
      title: "Module 3: Stock Exchanges and Their Role",
      content: [
        "How Stock Exchanges Operate",
        "Overview of major exchanges: NSE, BSE, NYSE, NASDAQ.",
        "How stock exchanges facilitate the buying and selling of shares.",
        "The role of exchanges in ensuring liquidity and price discovery."
      ]
    },
    {
      title: "Module 4: Key Players in the Stock Market",
      content: [
        "Understanding Market Participants",
        "Investors: Long-term and short-term investors, institutional investors.",
        "Traders: Active participants in buying and selling stocks for profit.",
        "Brokers: Role of intermediaries in executing buy and sell orders.",
        "Market Makers and Regulators: Ensuring smooth market operations and stability."
      ]
    },
    {
      title: "Module 5: Stocks and Shares",
      content: [
        "What Are Stocks?",
        "Definition of stocks and shares and the concept of ownership in a company.",
        "The difference between Common Shares and Preferred Shares.",
        "Rights of shareholders: Dividends, voting rights, and capital appreciation."
      ]
    },
    {
      title: "Module 6: Understanding Stock Trading",
      content: [
        "How Stock Trading Works",
        "Opening a brokerage account and placing orders (Market, Limit, Stop-loss).",
        "Types of orders and their significance in managing trades.",
        "The role of stock brokers and trading platforms in executing trades."
      ]
    },
    {
      title: "Module 7: Risk and Return in the Stock Market",
      content: [
        "Risk and Return Fundamentals",
        "Understanding the relationship between risk and potential return.",
        "Types of risks involved in stock market investments: market risk, inflation risk, liquidity risk.",
        "How to manage risk through diversification and asset allocation."
      ]
    },
    {
      title: "Module 8: Market Indices and Indicators",
      content: [
        "What Are Stock Market Indices?",
        "Understanding how stock market indices like Nifty, Sensex, and global indices track market performance.",
        "Economic indicators and their influence on stock prices: GDP, inflation, interest rates."
      ]
    },
    {
      title: "Module 9: Introduction to Fundamental Analysis",
      content: [
        "Evaluating Stocks Based on Financials",
        "How to analyze financial statements: income statement, balance sheet, cash flow.",
        "Key ratios: P/E ratio, Debt-to-equity ratio, Dividend yield, etc.",
        "How fundamental analysis helps in evaluating stock value and potential."
      ]
    },
    {
      title: "Module 10: Introduction to Technical Analysis",
      content: [
        "Reading Price Charts and Indicators",
        "Types of charts (line, bar, candlestick) and what they represent.",
        "Key technical indicators: Moving averages, RSI, MACD, and their role in identifying trends.",
        "How to spot support, resistance levels, and chart patterns like head-and-shoulders, double tops, etc."
      ]
    },
    {
      title: "Module 11: Building a Stock Portfolio",
      content: [
        "Principles of Stock Portfolio Management",
        "Importance of diversification to reduce risk.",
        "How to balance risk and return through asset allocation in your portfolio.",
        "Rebalancing your portfolio periodically and tracking performance."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Our Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UnderstandingOfStockMarketEssentialModule;
